<template>
  <div class="modal fade" id="changePasswordModal" tabindex="-1" data-bs-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Change Password</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="handleSubmit">
            <div class="mb-3">
              <label class="form-label">Current Password</label>
              <input
                type="password"
                class="form-control"
                v-model="form.currentPassword"
                required
              >
            </div>

            <div class="mb-3">
              <label class="form-label">New Password</label>
              <input
                type="password"
                class="form-control"
                v-model="form.newPassword"
                required
              >
            </div>

            <div class="mb-3">
              <label class="form-label">Confirm New Password</label>
              <input
                type="password"
                class="form-control"
                v-model="form.confirmPassword"
                required
              >
            </div>

            <div v-if="error" class="alert alert-danger">
              {{ error }}
            </div>

            <div class="text-end">
              <button type="button" class="btn btn-secondary me-2" @click="closeModal">
                Cancel
              </button>
              <button type="submit" class="btn btn-primary" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                Change Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { Modal } from 'bootstrap'

export default {
  name: 'ChangePasswordModal',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue', 'password-changed'],
  setup(props, { emit }) {
    const store = useStore()
    const loading = ref(false)
    const error = ref(null)
    let modal = null

    const form = ref({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    })

    onMounted(() => {
      modal = new Modal(document.getElementById('changePasswordModal'))
      watchEffect(() => {
        if (props.modelValue) {
          modal.show()
        } else {
          modal.hide()
        }
      })

      const modalElement = document.getElementById('changePasswordModal')
      modalElement.addEventListener('hidden.bs.modal', () => {
        emit('update:modelValue', false)
      })
    })

    onUnmounted(() => {
      if (modal) {
        modal.dispose()
      }
    })

    const handleSubmit = async () => {
      error.value = null

      if (form.value.newPassword !== form.value.confirmPassword) {
        error.value = 'New passwords do not match'
        return
      }

      loading.value = true
      try {
        await store.dispatch('changePassword', {
          currentPassword: form.value.currentPassword,
          newPassword: form.value.newPassword
        })
        emit('password-changed')
        closeModal()
      } catch (err) {
        error.value = err.message
      } finally {
        loading.value = false
      }
    }

    const closeModal = () => {
      emit('update:modelValue', false)
      form.value = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      error.value = null
    }

    return {
      form,
      loading,
      error,
      handleSubmit,
      closeModal
    }
  }
}
</script>
